<template>
    <tr>
        <td>{{ row.left.name }}</td>


<!--LEFT-->
        <template v-if="!row.left.is_deleted">
            <side-by-side-row-lvl1-autogoals :data="row.left"/>
            <side-by-side-row-lvl1-lead-setup :data="row.left"/>
            <side-by-side-row-lvl1-mc-goals :data="row.left"/>
            <side-by-side-row-lvl1-direct-goals :data="row.left"/>
            <side-by-side-row-lvl1-budget :data="row.left"/>
            <side-by-side-row-lvl1-ja :data="row.left"/>
            <side-by-side-row-lvl1-ff-order :data="row.left"/>
        </template>
        <template v-if="row.left.is_deleted">
            <side-by-side-row-lvl2-deleted :data="row.left" :colspan="colspan"/>
        </template>


<!--CENTER-->
        <td class="table-center-separator">
            <side-by-side-row-lvl2-locking-button :data="row.right" @locked="(x) => row.right.is_locked = x"/>
        </td>


<!--RIGHT-->
        <template v-if="!row.right.is_locked && !row.right.is_deleted">
            <side-by-side-row-lvl1-autogoals :data="row.right"/>
            <side-by-side-row-lvl1-lead-setup :data="row.right"/>
            <side-by-side-row-lvl1-mc-goals :data="row.right"/>
            <side-by-side-row-lvl1-direct-goals :data="row.right"/>
            <side-by-side-row-lvl1-budget :data="row.right"/>
            <side-by-side-row-lvl1-ja :data="row.right"/>
            <side-by-side-row-lvl1-ff-order :data="row.right"/>
        </template>
        <template v-if="row.right.is_locked && !row.right.is_deleted">
            <side-by-side-row-lvl2-locking-info :data="row.right" :colspan="colspan - 1"/>
            <side-by-side-row-lvl1-ff-order :data="row.right"/>
        </template>
        <template v-if="row.right.is_deleted">
            <side-by-side-row-lvl2-deleted :data="row.left" :colspan="colspan"/>
        </template>

        <td>
            <btn v-if="!is_open" icon="fas fa-chevron-down" :click="() => $emit('toggle')">Open</btn>
            <btn v-if="is_open" icon="fas fa-chevron-up" :click="() => $emit('toggle')">Close</btn>
        </td>
    </tr>
</template>

<script>
import SideBySideRowLvl1Autogoals from "./side-by-side-row-lvl1-autogoals";
import SideBySideRowLvl1LeadSetup from "./side-by-side-row-lvl1-lead-setup";
import SideBySideRowLvl1McGoals from "./side-by-side-row-lvl1-mc-goals";
import SideBySideRowLvl1DirectGoals from "./side-by-side-row-lvl1-direct-goals";
import SideBySideRowLvl1Budget from "./side-by-side-row-lvl1-budget";
import SideBySideRowLvl1Ja from "./side-by-side-row-lvl1-ja";
import SideBySideRowLvl1FfOrder from "./side-by-side-row-lvl1-ff-order";
import SideBySideRowLvl2Deleted from "./side-by-side-row-lvl2-deleted";
import SideBySideRowLvl2LockingButton from "./side-by-side-row-lvl2-locking-button";
import SideBySideRowLvl2LockingInfo from "./side-by-side-row-lvl2-locking-info";

export default {
    components: {
        SideBySideRowLvl2LockingInfo,
        SideBySideRowLvl2LockingButton,
        SideBySideRowLvl2Deleted,
        SideBySideRowLvl1FfOrder,
        SideBySideRowLvl1Ja,
        SideBySideRowLvl1Budget,
        SideBySideRowLvl1DirectGoals,
        SideBySideRowLvl1McGoals, SideBySideRowLvl1LeadSetup, SideBySideRowLvl1Autogoals
    },
    props: [
        'row',
        'is_open',
        'colspan'
    ]
}
</script>
